import { useCallback, useEffect, useState } from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { getProvidersSelector } from 'redux/selectors';
import { updateProviderConfirmOrder } from 'redux/actions/providers';
import { PROVIDER_AUTO_CONFIRM_ORDER, PROVIDER_NOT_CONFIRM_ORDER } from 'constants/providerStatuses';

const autoConfirmTakeOutInSchema = yup.object().shape({
  orderConfirm: yup.object().shape({
    dine_in: yup.object().shape({
      autoConfirm: yup.boolean(),
    }),
  }),
});

const autoConfirmTakeOutDefaultValue = {
  orderConfirm: {
    dine_in: {
      autoConfirm: false,
    },
  },
};

const useTakeOutAutoConfirm = (items, srv) => {
  const dispatch = useDispatch();
  const { providerId } = useSelector(getProvidersSelector);
  const [loading, setLoading] = useState(false);

  const autoConfirmTakeOut = useForm({
    defaultValues: autoConfirmTakeOutDefaultValue,
    mode: 'all',
    resolver: yupResolver(autoConfirmTakeOutInSchema),
  });

  useEffect(() => {
    const findProviderConfirm = items.find((item) => item?.srv === srv);
    if (findProviderConfirm) {
      if (findProviderConfirm?.orderConfirm?.take_out) {
        autoConfirmTakeOut.reset({
          orderConfirm: {
            take_out: {
              autoConfirm: findProviderConfirm?.orderConfirm?.take_out?.autoConfirm,
            },
          },
        });
      }
    }
  }, [items, srv]);

  const handleSubmit = () => {};

  const handleConfirm = useCallback((event) => {
    const { checked } = event.target;
    setLoading(true);
    dispatch(
      updateProviderConfirmOrder(
        {
          id: providerId,
          confirmOrder: checked ? PROVIDER_AUTO_CONFIRM_ORDER : PROVIDER_NOT_CONFIRM_ORDER,
          provider: srv,
          orderConfirm: {
            take_out: {
              autoConfirm: checked,
            },
          },
        },
        false
      )
    )
      .then(() => {})
      .finally(() => setLoading(false));
  }, []);

  return {
    autoConfirmTakeOut,
    handleSubmit,
    handleConfirm,
    loading,
  };
};

export default useTakeOutAutoConfirm;
